<template>
  <div class="kds-toggle" role="group" :aria-label="ariaLabel">
    <button
      v-for="option in options"
      :key="option.value"
      type="button"
      class="kds-toggle__option"
      :class="{ 'kds-toggle__option--active': option.value === modelValue }"
      :aria-pressed="option.value === modelValue ? 'true' : 'false'"
      @click="onSelect(option.value)"
    >
      {{ option.label }}
    </button>
  </div>
</template>

<script setup lang="ts">
import type { KdsToggleOption } from '@/kds/types';

interface Props {
  modelValue: string;
  options: KdsToggleOption[];
  ariaLabel?: string;
}

defineProps<Props>();

const emit = defineEmits<{
  'update:modelValue': [value: string];
}>();

function onSelect(value: string) {
  emit('update:modelValue', value);
}
</script>

<style scoped lang="scss">
.kds-toggle {
  display: inline-flex;
  align-items: center;
  gap: 0;
  padding: 4px;
  background: var(--paper-2);
  border: var(--bw) solid var(--mist);
  border-radius: var(--r-pill);

  &__option {
    appearance: none;
    border: none;
    background: transparent;
    color: var(--stone);
    font-family: var(--font-ui);
    font-size: var(--fs-body-sm);
    font-weight: var(--fw-medium);
    padding: 6px 16px;
    border-radius: var(--r-pill);
    cursor: pointer;
    transition:
      background-color var(--d-base) var(--ease-out),
      color var(--d-base) var(--ease-out),
      box-shadow var(--d-base) var(--ease-out);

    &:focus-visible {
      outline: none;
      box-shadow: var(--shadow-focus);
    }

    &--active {
      background: var(--paper);
      color: var(--ink);
      box-shadow: var(--shadow-1);
    }
  }
}
</style>
